import React from 'react';
import dialog_question from "../../assets/images/dialog_question.png";
import {dayOfMonths, months, yearStartToCurrent} from "../../constant/General";

const LookUpLotteryResults = () => {
    return (
        <div>
            <div className="modulesLR moduleBrown">
                <div className="title-l">
                    <div className="title-r">
                        <h1>Tra Cứu Kết Quả Xổ Số</h1>
                    </div>
                </div>
                <div className="body-l">
                    <div className="body-r">
                        <div id="box_tracuukqxs">
                            <table width="100%" align="center"
                                   cellPadding="0" cellSpacing="5">
                                <tbody>
                                <tr align="left" valign="middle">
                                    <td><label> <input name="slquery"
                                                       type="radio"
                                                       id="slquery_0"
                                                       defaultChecked
                                                       defaultValue="1"
                                    />Miền</label></td>
                                    <td><label> <input type="radio"
                                                       name="slquery"
                                                       defaultValue="2"
                                                       id="slquery_1"/>
                                        Tỉnh</label></td>
                                    <td><label> <input type="radio"
                                                       name="slquery"
                                                       defaultValue="3"
                                                       id="slquery_2"
                                    />
                                        Đầu đuôi</label></td>
                                </tr>
                                </tbody>
                            </table>
                            <div id="tc_mien">
                                <form id="tracuukqxs"
                                      name="tracuukqxs" method="get"
                                      style={{fontSize: "10px"}}>
                                    <table style={{border: "0", cellSpacing: "0", cellPadding: "2", width: "100%"}}>
                                        <tbody>
                                        <tr>
                                            <td style={{paddingButton: "10px", align: "center", nowrap: "nowrap"}}>
                                                <select name="mien"
                                                        id="mien"
                                                        style={{width: "88px"}}>
                                                    <option defaultValue="0">
                                                        Chọn Miền
                                                    </option>
                                                    <option defaultValue="1">
                                                        Miền Nam
                                                    </option>
                                                    <option defaultValue="2">
                                                        Miền Bắc
                                                    </option>
                                                    <option defaultValue="3">
                                                        Miền Trung
                                                    </option>
                                                    <option defaultValue="4">
                                                        Vietlott
                                                    </option>
                                                </select> <select
                                                name="thu" id="thu"
                                                style={{width: "88px"}}>
                                                <option defaultValue="0">
                                                    Chọn thứ
                                                </option>
                                                <option defaultValue="1">
                                                    Chủ Nhật
                                                </option>
                                                <option defaultValue="7">
                                                    Thứ Bảy
                                                </option>
                                                <option defaultValue="6">
                                                    Thứ Sáu
                                                </option>
                                                <option defaultValue="5">
                                                    Thứ Năm
                                                </option>
                                                <option defaultValue="4">
                                                    Thứ Tư
                                                </option>
                                                <option defaultValue="3">
                                                    Thứ Ba
                                                </option>
                                                <option defaultValue="2">
                                                    Thứ Hai
                                                </option>
                                            </select></td>
                                        </tr>
                                        <tr>
                                            <td nowrap="nowrap"
                                                style={{
                                                    paddingBottom: "10px",
                                                    align: "center"
                                                }}><select
                                                name="ngay"
                                                id="ngay"
                                                style={{width: "57px"}}>
                                                <option defaultValue="">
                                                    Ngày
                                                </option>
                                                {dayOfMonths.map((e, i) => <option key={i} defaultValue={i + 1}>
                                                    {i + 1}
                                                </option>)}
                                            </select> <select
                                                name="thang"
                                                id="thang"
                                                style={{width: "62px"}}>
                                                <option defaultValue="">
                                                    Tháng
                                                </option>
                                                {months.map((e, i) => <option key={i} defaultValue={`${e}`}>
                                                    {i + 1}
                                                </option>)}
                                            </select> <select
                                                name="nam" id="nam"
                                                style={{width: "54px"}}>
                                                <option defaultValue="">N&#259;m</option>
                                                {yearStartToCurrent.map((e, i) => <option key={i}
                                                                                          defaultValue={`${e - i}`}>
                                                    {e - i}
                                                </option>)}
                                            </select></td>
                                        </tr>
                                        <tr>
                                            <td align="center"><input
                                                type="submit"
                                                value="Xem kết quả"/>
                                                <a href="/"><img src={dialog_question} border="0" align="absmiddle"
                                                                 alt=""/>
                                                </a>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LookUpLotteryResults;
